<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg h-96">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Duration</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-2 sm:col-span-2">

                            <FormMultiselect
                            required
                            label="Start Month"
                            :options="months"
                            track-key="id"
                            label-key="title"
                            :object="true"
                            v-model="form.start_month"
                            :placeholder="'Start Month'"
                            :error="form.errors.start_month"
                            />

                        </div>
                        <div class="col-span-2 sm:col-span-2">

                            <FormMultiselect
                            required
                            label="End Month"
                            :options="months"
                            track-key="id"
                            label-key="title"
                            :object="true"
                            v-model="form.end_month"
                            :placeholder="'End Month'"
                            :error="form.errors.end_month"
                            />

                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Code'"/>
                            <breeze-input required v-model="form.code" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.code:''" />
                        </div>
                        <div class="">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <button-link :href="route('academic.duration.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import InputCheckbox from '@/Components/InputCheckbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Loading from '@/Components/Loading'
    import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

    export default {
        components: {
            FormMultiselect,
            Academic,
            BreezeTable,
            ButtonLink,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            InputCheckbox,
            Loading,
            SelectList
        },
        data(){
            return{
                form: useForm({
                    start_month: '',
                    end_month: '',
                    code: '',
                    status: true,
                }),
                months:[{id:'January',title:'January'},{id:'February',title:'February'},{id:'March',title:'March'},{id:'April',title:'April'},{id:'May',title:'May'},{id:'June',title:'June'},{id:'July',title:'July'},{id:'August',title:'August'},{id:'September',title:'September'},{id:'October',title:'October'},{id:'November',title:'November'},{id:'December',title:'December'}]
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('academic.duration.store'),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
        },
    }
</script>
